import React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import {
  ChevronLeft as PrevIcon,
  ChevronRight as NextIcon
} from '@mui/icons-material';
import { useIsMobile } from '../../../../hooks/useResponsive';
import { getLocationName } from '../../utils/locationTransformers';

/**
 * Compact sibling navigation control
 * Shows < Previous | Current (n of m) | Next >
 * Touch-friendly on mobile (48px minimum targets)
 */
const SiblingNavigator = ({ prev, next, index, total, onNavigate }) => {
  const isMobile = useIsMobile();

  if (total <= 1) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      <Tooltip title={prev ? `Previous: ${getLocationName(prev)}` : 'No previous'}>
        <span>
          <IconButton
            size={isMobile ? 'medium' : 'small'}
            disabled={!prev}
            onClick={() => prev && onNavigate(prev)}
            aria-label={prev ? `Previous: ${getLocationName(prev)}` : 'No previous'}
            sx={isMobile ? { minWidth: 44, minHeight: 44 } : {}}
          >
            <PrevIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Typography variant="caption" color="text.secondary" sx={{ mx: 0.25, whiteSpace: 'nowrap' }}>
        {index + 1}/{total}
      </Typography>

      <Tooltip title={next ? `Next: ${getLocationName(next)}` : 'No next'}>
        <span>
          <IconButton
            size={isMobile ? 'medium' : 'small'}
            disabled={!next}
            onClick={() => next && onNavigate(next)}
            aria-label={next ? `Next: ${getLocationName(next)}` : 'No next'}
            sx={isMobile ? { minWidth: 44, minHeight: 44 } : {}}
          >
            <NextIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default SiblingNavigator;
